function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["endpoint", "lang", "strings", "feedback", "doAnalytics", "pageData", "idCookieName", "linkType", "stream", "useDefaultStrings"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import { AIChat, NoticeMessage, SentMessage, ReceivedMessage, Feedback } from '@churchofjesuschrist/ai-chat';
import { Info } from '@churchofjesuschrist/eden-alert';
import { spacing8, accentColorLink, breakWidth480 } from '@churchofjesuschrist/eden-style-constants';
import { A11y } from '@churchofjesuschrist/eden-buttons';
import { useMediaQuery } from '@churchofjesuschrist/eden-media-query';
import { useAnalytics } from "../hooks/useAnalytics.mjs";
import { useMessages } from "../hooks/useMessages.mjs";
import { CONTENT_FILTERED, CONVERSATION_RESET, MESSAGE_LENGTH_EXCEEDED, RATE_LIMITED } from "../utils/message-status.mjs";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var MAX_MESSAGE_LENGTH = 200;
var NOOP = function NOOP() {};
var LegalMessage = styled(Info).withConfig({
  componentId: "sc-184701b-0"
})(["position:absolute;left:", ";right:", ";z-index:1;max-height:70%;height:fit-content;overflow-y:auto;overscroll-behavior:contain;& > div::before{height:calc(100% + 1px);}"], spacing8, spacing8);
var LegalContent = styled.div.withConfig({
  componentId: "sc-184701b-1"
})(["max-width:100%;max-height:100%;word-break:break-word;overflow-y:auto;overscroll-behavior:contain;"]);
var LinkButton = styled(A11y).withConfig({
  componentId: "sc-184701b-2"
})(["color:", ";text-decoration:underline;&:hover{text-decoration:none;}"], accentColorLink);

/**
 * @typedef {object} Strings
 * @property {string} [title]
 * @property {string} [footer]
 * @property {string} [learnMore]
 * @property {string} [resetLabel]
 * @property {string} [placeholder]
 * @property {string} [openLabel]
 * @property {string} [closeLabel]
 * @property {string} [fabText] Only displayed on screens >=480px
 * @property {string} [legalMessage]
 * @property {string} [startMessage]
 * @property {string} [resetMessage]
 * @property {string} [errorRateLimited]
 * @property {string} [errorMessageLength]
 * @property {string} [errorContentFiltered]
 * @property {string} [errorOther]
 * @property {string} [feedbackTitle]
 * @property {string} [feedbackPlaceholder]
 * @property {string} [feedbackSubmitted]
 */

/**
 * @typedef {object} Props
 * @property {string} endpoint The backend endpoint to send chatbot requests to.
 * @property {string} lang Three-letter language code to forward to the chatbot backend.
 * @property {boolean} [feedback] Whether to accept message feedback. Defaults to `true`.
 * @property {boolean} [doAnalytics] Whether to push analytics to the data layer.
 * @property {{ [key: string]: any }} [pageData] Page data to include in analytics events.
 *
 * - `info.siteName` is required.
 * - `info.name` will be built from the current URL if not provided.
 *
 * See {@link https://confluence.churchofjesuschrist.org/display/ContMed/Data+Layer+-+General#DataLayerGeneral-page|Data Layer - General (Confluence)} for details.
 * @property {Strings} strings An object containing translated strings for the chatbot UI. Some strings have English defaults.
 * @property {string} [idCookieName] The name of the cookie containing an oauth id token. If provided, the chatbot will validate the token as part of the access check before showing the chatbot.
 * @property {React.ComponentType} [linkType] The component to use for links in chatbot messages. Defaults to an anchor tag.
 * @property {boolean} [stream] Whether to stream responses from the backend. Defaults to `false`.
 * @property {boolean} [useDefaultStrings] Whether to load default UI strings from the backend. Defaults to `false`.
 */

/**
 * @typedef {Omit<Parameters<AIChat>[0], 'open'|'loading'|'title'|'footer'|'resetLabel'|'placeholder'|'openLabel'|'closeLabel'|'onOpen'|'onClose'|'onMessage'|'onReset'|'validationMessage'|'inputProps'|'fabText'|'hideFab'|'children'>} PassthroughProps
 */

/**
 * @param {Props & PassthroughProps} props
 */
var ChatBot = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _messages$at;
  var endpoint = _ref.endpoint,
    lang = _ref.lang,
    _ref$strings = _ref.strings,
    strings = _ref$strings === void 0 ? {} : _ref$strings,
    _ref$feedback = _ref.feedback,
    feedback = _ref$feedback === void 0 ? true : _ref$feedback,
    _ref$doAnalytics = _ref.doAnalytics,
    doAnalytics = _ref$doAnalytics === void 0 ? false : _ref$doAnalytics,
    pageData = _ref.pageData,
    idCookieName = _ref.idCookieName,
    linkType = _ref.linkType,
    stream = _ref.stream,
    _ref$useDefaultString = _ref.useDefaultStrings,
    useDefaultStrings = _ref$useDefaultString === void 0 ? false : _ref$useDefaultString,
    props = _objectWithoutProperties(_ref, _excluded);
  var defaultStringCache = useRef({});
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    defaultStrings = _useState2[0],
    setDefaultStrings = _useState2[1];
  var _strings = _objectSpread(_objectSpread({}, defaultStrings !== null && defaultStrings !== void 0 ? defaultStrings : {}), strings),
    title = _strings.title,
    footer = _strings.footer,
    learnMore = _strings.learnMore,
    resetLabel = _strings.resetLabel,
    placeholder = _strings.placeholder,
    openLabel = _strings.openLabel,
    closeLabel = _strings.closeLabel,
    fabText = _strings.fabText,
    _strings$legalMessage = _strings.legalMessage,
    legalMessage = _strings$legalMessage === void 0 ? 'This artificial intelligence (AI) search assistant is powered by generative AI technology that references the Church General Handbook. This search assistant can analyze questions, search the Church General Handbook, and summarize potentially relevant information. Generative AI is not always correct. Please personally confirm the answers provided by this search assistant by reading the sections it identifies in the Handbook. Use of this search assistant is anonymous. Do not enter any personal information. By using this search assistant, you agree that anything you enter can be saved and reviewed by Church personnel to improve this search assistant and make it more accurate.<br><br>Please take a brief survey to let us know about your experience: <a href="https://research.churchofjesuschrist.org/jfe/form/SV_cIU0yAak9f0CYWW">https://research.churchofjesuschrist.org/jfe/form/SV_cIU0yAak9f0CYWW</a>' : _strings$legalMessage,
    startMessage = _strings.startMessage,
    _strings$resetMessage = _strings.resetMessage,
    resetMessage = _strings$resetMessage === void 0 ? 'The conversation has now been reset. Your previous messages will not be remembered.' : _strings$resetMessage,
    errorRateLimited = _strings.errorRateLimited,
    errorContentFiltered = _strings.errorContentFiltered,
    errorMessageLength = _strings.errorMessageLength,
    errorOther = _strings.errorOther,
    feedbackTitle = _strings.feedbackTitle,
    feedbackPlaceholder = _strings.feedbackPlaceholder,
    feedbackSubmitted = _strings.feedbackSubmitted;

  // If there is not a "learn more" string, show the legal message by default.
  var _useState3 = useState(!learnMore && (useDefaultStrings ? undefined : true)),
    _useState4 = _slicedToArray(_useState3, 2),
    showLegal = _useState4[0],
    setShowLegal = _useState4[1];
  useEffect(function () {
    if (!useDefaultStrings) {
      return;
    }
    if (defaultStringCache.current[lang]) {
      setDefaultStrings(defaultStringCache.current[lang]);
      return;
    }
    var cancel = false;
    fetch("".concat(endpoint, "/strings/").concat(lang, ".json")).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!cancel && res.ok)) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return res.json();
            case 3:
              result = _context.sent;
              defaultStringCache.current[lang] = result;
              setDefaultStrings(result);
              if (showLegal === undefined) {
                setShowLegal(!result.learnMore);
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return function () {
      cancel = true;
    };
  }, [lang, endpoint, useDefaultStrings, showLegal]);
  var _useMessages = useMessages({
      endpoint: endpoint,
      lang: lang,
      idCookieName: idCookieName,
      stream: stream
    }),
    ready = _useMessages.ready,
    loading = _useMessages.loading,
    messages = _useMessages.messages,
    conversationId = _useMessages.conversationId,
    resetConversation = _useMessages.resetConversation,
    sendFeedback = _useMessages.sendFeedback,
    sendMessage = _useMessages.sendMessage;
  var analytics = useAnalytics(doAnalytics, lang, pageData);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  useImperativeHandle(ref, function () {
    return {
      open: function open() {
        return setOpen(true);
      },
      close: function close() {
        return setOpen(false);
      }
    };
  });
  var _useMediaQuery = useMediaQuery(NOOP, "(min-width: ".concat(breakWidth480, ")")),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    showFabText = _useMediaQuery2[0];
  var handleOpen = function handleOpen() {
    setOpen(true);
    analytics.widgetOpened();
  };
  var handleClose = function handleClose() {
    setOpen(false);
    analytics.widgetClosed();
  };
  var handleMessage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(message) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (message) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            if (!conversationId) {
              analytics.chatInitiated();
            }
            analytics.questionAsked();
            _context2.next = 6;
            return sendMessage(message);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleMessage(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleReset = function handleReset() {
    resetConversation();
    analytics.chatInitiated();
  };
  var handleFeedback = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(cid, index, feedback) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (feedback.message) {
              analytics.feedbackSubmitted(feedback.positive);
            } else {
              analytics.feedbackClicked(feedback.positive);
            }
            _context3.next = 3;
            return sendFeedback({
              cid: cid,
              index: index
            }, feedback);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleFeedback(_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  if (!ready || useDefaultStrings && defaultStrings === undefined) {
    return;
  }
  var loadingMessage = ((_messages$at = messages.at(-1)) === null || _messages$at === void 0 ? void 0 : _messages$at.done) === false;
  return /*#__PURE__*/_jsxs(AIChat, _objectSpread(_objectSpread({}, props), {}, {
    open: open,
    loading: loading && !loadingMessage,
    disabled: loading,
    title: title,
    footer: !!footer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [footer, learnMore && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(LinkButton, {
          onClick: function onClick() {
            analytics.learnMoreClicked();
            setShowLegal(true);
          },
          "data-testid": "learn-more",
          children: learnMore
        })]
      })]
    }),
    resetLabel: resetLabel,
    placeholder: placeholder,
    openLabel: openLabel,
    closeLabel: closeLabel,
    onOpen: handleOpen,
    onClose: handleClose,
    onMessage: handleMessage,
    onReset: handleReset,
    validationMessage: errorMessageLength,
    inputProps: {
      maxLength: MAX_MESSAGE_LENGTH
    },
    fabText: showFabText && fabText,
    hideFab: !showFabText && open,
    children: [legalMessage && showLegal && /*#__PURE__*/_jsx(LegalMessage, {
      onClose: function onClose() {
        return setShowLegal(false);
      },
      "data-testid": "legal",
      children: /*#__PURE__*/_jsx(LegalContent, {
        dangerouslySetInnerHTML: {
          __html: legalMessage
        }
      })
    }), startMessage && /*#__PURE__*/_jsx(NoticeMessage, {
      children: startMessage
    }), messages.map(function (_ref5) {
      var id = _ref5.id,
        role = _ref5.role,
        content = _ref5.content,
        index = _ref5.index,
        cid = _ref5.cid,
        status = _ref5.status,
        done = _ref5.done;
      if (status) {
        if (status === RATE_LIMITED && errorRateLimited) {
          // backend hit quota, try again later
          return /*#__PURE__*/_jsx(NoticeMessage, {
            children: errorRateLimited
          }, id);
        } else if (status === CONTENT_FILTERED && errorContentFiltered) {
          // content filtration, reset conversation
          return /*#__PURE__*/_jsx(NoticeMessage, {
            children: errorContentFiltered
          }, id);
        } else if (status === MESSAGE_LENGTH_EXCEEDED && errorMessageLength) {
          return /*#__PURE__*/_jsx(NoticeMessage, {
            children: errorMessageLength
          }, id);
        } else if (status === CONVERSATION_RESET && resetMessage) {
          // reset conversation
          return /*#__PURE__*/_jsx(NoticeMessage, {
            children: resetMessage
          }, id);
        } else if (errorOther) {
          // other error
          return /*#__PURE__*/_jsx(NoticeMessage, {
            children: errorOther
          }, id);
        }
        return;
      }
      if (role === 'user') {
        return /*#__PURE__*/_jsx(SentMessage, {
          children: content
        }, id);
      }
      if (role === 'assistant') {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(ReceivedMessage, {
            citationPrefix: "^",
            linkType: linkType,
            citationsList: done,
            children: content
          }), feedback && done && /*#__PURE__*/_jsx(Feedback, {
            onFeedback: function onFeedback(feedback) {
              return handleFeedback(cid, index, feedback);
            },
            title: feedbackTitle,
            placeholder: feedbackPlaceholder,
            submittedMessage: feedbackSubmitted
          })]
        }, id);
      }
    })]
  }));
});
ChatBot.displayName = 'ChatBot';
export default ChatBot;